import React from "react";
import BaseIcon from "./base";

const AddDoc = (props) => {
	return (
		<BaseIcon>
			<path
				d="M731,5643H717a1,1,0,0,1,0-2h14A1,1,0,0,1,731,5643Zm0,4H717a1,1,0,0,1,0-2h14A1,1,0,0,1,731,5647Zm0,4H717a1,1,0,0,1,0-2h14A1,1,0,0,1,731,5651Zm-4,4H717a1,1,0,0,1,0-2h10A1,1,0,0,1,727,5655Zm8,4a1,1,0,0,1-1-1v-8a1,1,0,0,1,2,0v8A1,1,0,0,1,735,5659Zm4-4h-8a1,1,0,0,1,0-2h8A1,1,0,0,1,739,5655Z"
				transform="translate(-716 -5641)"
			/>
		</BaseIcon>
	);
};

export default AddDoc;
